@let isLoading =
  store
    .ecSg()
    ?.plugins?.currentListPlugin?.feature?.selectors?.isLoading?.asSignal();
@let error =
  store
    .ecSg()
    ?.plugins?.currentListPlugin?.feature?.selectors?.error?.asSignal();

@if (isLoading) {
  <!-- ----------------------------------------------------------------------- -->
  <!--                         Loading state template                          -->
  <!-- ----------------------------------------------------------------------- -->
  <atn-ds-loader type="table" />
} @else if (error) {
  <!-- ----------------------------------------------------------------------- -->
  <!--                          Error state template                           -->
  <!-- ----------------------------------------------------------------------- -->
  <div class="atn-ds-table-empty-state">
    <atn-ds-empty-state
      description="The data did not load properly. Usually refreshing fixes
  this problem. Try the button below. If the problem persist contact
  support."
      layout="h"
      title="Something went wrong"
      type="error"
      (action)="emptyStateClickHandler('error')"
    />
  </div>
} @else {
  <!-- ----------------------------------------------------------------------- -->
  <!--                          Empty state template                           -->
  <!-- ----------------------------------------------------------------------- -->
  <!-- NOTE: To prevent flickering, there is a slight delay between
  clearing the cache (when entities.length === 0) and initializing a
  new API request (which sets the loader to true). Therefore, we
  defer displaying the empty state template for a short period of
  time. -->
  @defer (on timer(200)) {
    <div class="atn-ds-table-empty-state">
      <atn-ds-empty-state
        layout="h"
        [title]="titleSg()"
        [description]="descriptionSg()"
        [action]="actionSg()"
        [type]="typeSg()"
        (action)="emptyStateClickHandler('empty')"
      />
    </div>
  }
}
